import { __extends } from "tslib";
import { GetSegmentVersionRequest, GetSegmentVersionResponse } from "../models/index";
import { deserializeAws_restJson1GetSegmentVersionCommand, serializeAws_restJson1GetSegmentVersionCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetSegmentVersionCommand = /** @class */ (function (_super) {
    __extends(GetSegmentVersionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetSegmentVersionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetSegmentVersionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: GetSegmentVersionRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetSegmentVersionResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetSegmentVersionCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetSegmentVersionCommand(input, context);
    };
    GetSegmentVersionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetSegmentVersionCommand(output, context);
    };
    return GetSegmentVersionCommand;
}($Command));
export { GetSegmentVersionCommand };
//# sourceMappingURL=GetSegmentVersionCommand.js.map